export enum ExtractionModel {
  GPT_4O = "GPT 4-o",
  GPT_41 = "GPT 4.1",
  DOC_AI_GPT_4O = "DOC AI + GPT 4-o",
  AZURE_AI_DOC_AI_GPT_41 = "Azure AI Search + Doc AI + GPT 4.1",
  SELECT_MODEL = "Select Model"
}

export const EXTRACTION_MODEL_ENDPOINTS: Record<ExtractionModel, string> = {
  [ExtractionModel.GPT_4O]: "/api/extract-document-gpt4o",
  [ExtractionModel.GPT_41]: "/api/extract-document-gpt41",
  [ExtractionModel.DOC_AI_GPT_4O]: "/api/extract-document-docai-gpt4o",
  [ExtractionModel.AZURE_AI_DOC_AI_GPT_41]:
    "/api/extract-document-azureai-docai-gpt41",
  [ExtractionModel.SELECT_MODEL]: ""
};
